import { render, staticRenderFns } from "./ProjectSection.vue?vue&type=template&id=3c17c3d8&scoped=true&"
import script from "./ProjectSection.vue?vue&type=script&lang=js&"
export * from "./ProjectSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSection.vue?vue&type=style&index=0&id=3c17c3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c17c3d8",
  null
  
)

export default component.exports